import { Injectable } from '@angular/core';
import { Http, Headers } from '@angular/http';
import { environment } from '../../environments/environment';

@Injectable()
export class AppService {
  apiUrl: string;
  userUpdatedSubscription: any;
  headers: any;

  constructor(public http: Http) {
    this.apiUrl = environment.baseUrl + '/cms/';
    this.headers = new Headers();
    this.headers.append('Content-Type', 'application/json');
  }

  getPlatformFeatures(language: string) {
    return this.http.get(this.apiUrl + 'platform_features/' + language);
  }

  getHomepage(language: string) {
    return this.http.get(this.apiUrl + 'homepage/' + language);
  }

  getHomepageSlides(language: string) {
    return this.http.get(this.apiUrl + 'homepage_slides/' + language);    
  }

  getImagesGallery() {
    return this.http.get(this.apiUrl + 'image_gallery');
  }

  getWorkouts(language: string) {
    return this.http.get(this.apiUrl + 'workout/' + language);  
  }

  getArticles(language: string) {
    return this.http.get(this.apiUrl + 'articles/' + language);  
  }

  getArticle(nid: string, language: string) {
    return this.http.get(this.apiUrl + 'article/' + language + '/' + nid);
  }

  getMenu(language: string) {
    return this.http.get(this.apiUrl + 'menu/' + language)
  }

  getTechnology(language: string) {
    return this.http.get(this.apiUrl + 'technology/' + language);
  }

  getGym(language: string) {
    return this.http.get(this.apiUrl + 'gym/' + language);
  }

  getPackageTypes(language: string) {
    return this.http.get(this.apiUrl + 'package_type/' + language);
  }

  getXCSRFToken() {
    return this.http.get(this.apiUrl + 'rest/session/token');
  }

  sendContactMessage(xcsrfToken: string, name: string, email: string, message: string) {
    this.headers.append('X-CSRF-Token', xcsrfToken);
    return this.http.post(this.apiUrl + 'entity/node', {
      "type": [
        {
          "target_id": "contact"
        }
      ],
      "title": [
        {
          "value": name + ' - ' + email
        }
      ],
      "field_email": [
        {
          "value": email
        }
      ],
      "field_name": [
        {
          "value": name
        }
      ],
      "field_message": [
        {
          "value": message
        }
      ]
    }, {
      headers: this.headers
    });
  }
}


// WEBPACK FOOTER //
// ./src/app/providers/app.service.ts